

export function createEmergencyContactList(emergencyContacts) {
    let list = []

    emergencyContacts.forEach(contact => {

        let listItem = {
            ...contact,
            name: `${contact.firstName} ${contact.lastName}`
        }

        list.push(listItem)
    })

    return list
}